import { ILocation } from './location.interface';
import { ILuggage } from './luggage.interface';
import { ITimePeriod } from './time-period.interface';

export enum CoordinateSource {
  NearMe = 'NearMe',
  SelectPlace = 'SelectPlace',
  UrlParams = 'UrlParams',
  MapPanning = 'MapPanning',
  IPGeoLocation = 'IPGeoLocation',
}

export interface StorageCriteria {
  location?: ILocation;
  period?: ITimePeriod;
  luggage?: ILuggage;
  activeOnly: boolean;
  coordinateSource?: CoordinateSource;
  toString(): string;
  equals(other: StorageCriteria, includeTime?: boolean): boolean;
}
